import React from 'react';

import { flagStyles } from '../settings';

const SvgBG = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-480px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBG;
